import React from 'react'

export const ChangeButtonPrincipal = ({size, text, statePrincipal, setStatePrincipal, setStateSecond}) => {
  return (
    <button className={`w-[${size}] h-8 rounded
    ${statePrincipal==='active' ? "bg-[#ccc]": "bg-[#5e5e5e] text-white"}`} onClick={()=> {setStatePrincipal('active'); setStateSecond('')}}>{text}</button>
  )
}